export const messages =  {
  en: {
    supplierCoupon: {
      title: 'Supplier Coupon Management',
      searchConditions: 'Search Conditions',
      couponInfo: 'Coupon Information',
      name: 'Name',
      businessId: 'Business ID',
      supplier: 'Supplier',
      thirdPartyId: 'Third-party ID',
      price: 'Price',
      remark: 'Remark',
      operation: 'Operation',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      confirm: 'Confirm',
      cancel: 'Cancel',
      deleteConfirm: 'Are you sure to delete this coupon?',
      deleteTitle: 'Confirm Operation',
      required: 'Required',
      addTitle: 'Add Coupon',
      editTitle: 'Edit Coupon',
      search: 'Search',
      noData: 'No data',
      supplierRequired: 'Please select a supplier first'
    }
  },
  zh: {
    supplierCoupon: {
      title: '供应商优惠券管理',
      searchConditions: '查询条件',
      couponInfo: '优惠券信息',
      name: '名称',
      businessId: '业务ID',
      supplier: '供应商',
      thirdPartyId: '三方ID',
      price: '售价',
      remark: '备注',
      operation: '操作',
      add: '添加',
      edit: '修改',
      delete: '删除',
      confirm: '确认',
      cancel: '取消',
      deleteConfirm: '确定删除优惠券？',
      deleteTitle: '请确认您的操作',
      required: '必填',
      addTitle: '添加优惠券',
      editTitle: '修改优惠券',
      search: '查询',
      noData: '暂无数据',
      supplierRequired: '请先选择供应商'
    }
  }
}